@if(loader){
<app-loader></app-loader>
}

<p-card>
    <div class="">
        <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
            <div class="flex align-items-center">
                <div>
                    <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                        (onClick)="CreateVendor()" pTooltip="Create Vendor"></p-button>

                </div>

                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                            class=" p-inputtext-sm" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;"
                            (keyup.enter)="searchVendor()" />

                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchVendor()" [raised]="true" [size]="'small'"
                        severity="info" [ngStyle]="{ height: '35px' }" class="ml-2"></p-button>
                </div>

                <p-button *ngIf="selectedVendor && selectedVendor.length == 1" label="Edit" class="ml-2"
                    icon="pi pi-user-edit" (click)="editVendor()" size="small" severity="secondary"></p-button>
                <p-button *ngIf="selectedVendor && selectedVendor.length > 0" label="Delete" class="ml-2"
                    icon="pi pi-trash" (click)="deleteVendor()" size="small" severity="danger"></p-button>
            </div>

            <h2 class="mb-0 fw-bold page-title-center" style="top: 66px;">Vendor List</h2>

            <div class="flex">
                <div class="flex align-items-center">
                    <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true"
                        severity="info"></p-button>
                </div>
            </div>
        </div>


        <p-table #dt1 [value]="result.vendors" [scrollable]="true" scrollHeight="630px" styleClass="p-datatable-striped"
            responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10"
            (onPage)="loadvendors($event)" [(selection)]="selectedVendor"
            [globalFilterFields]="['vendorCode','vendorName','mobile','email','address.addressLine1','address.city','address.state']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10 ,15, 20]">
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <!-- <th>Image</th> -->
                    <th>Vendor Code</th>
                    <th>Vendor Name</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    <th>Address</th>
                    <th>City</th>
                    <th>State</th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-vendor>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="vendor"></p-tableCheckbox>
                    </td>
                    <!-- <td>
                        <p-image [src]="vendor.vendorImage"
                            [alt]="vendor.vendorImage ? 'Vendor Image' : 'No Image Available'" width="30"
                            [preview]="true">
                        </p-image>
                    </td> -->
                    <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editVendor(vendor.vendorId)">
                        {{vendor.vendorCode}}</td>
                    <td>{{vendor.vendorName}}</td>
                    <td>{{vendor.mobile}}</td>
                    <td>{{vendor.email}}</td>
                    <td>{{vendor.address?.addressLine1}}</td>
                    <td>{{vendor.address?.city}}</td>
                    <td>{{vendor.address?.state}}</td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>